import { motion } from 'motion/react';

const EASE = [0.165, 0.84, 0.44, 1] as const;

/**
 * A horizontal bar chart with no charting library.
 *
 * `costMicro` drives the bar's *width* only — the on-screen number for each
 * row is always rendered from the original decimal string with
 * `formatUsageCost`/`formatTHB` from src/lib/money.ts, never from a value
 * derived here. Converting a bigint ratio to a `Number` for a CSS
 * percentage is a pixel-proportion calculation, not a monetary one, so it
 * does not touch the no-float-money rule — nothing financial is computed or
 * displayed from it.
 */
export function BarList({
  items,
}: {
  items: { key: string; label: string; costMicro: bigint; valueLabel: string }[];
}) {
  const max = items.reduce((m, i) => (i.costMicro > m ? i.costMicro : m), 1n);

  return (
    <div className="bar-list">
      {items.map((item) => {
        const ratio = max > 0n ? Number((item.costMicro * 10_000n) / max) / 10_000 : 0;
        return (
          <div className="bar-row" key={item.key}>
            <span className="bar-label" title={item.label}>
              {item.label}
            </span>
            <div className="bar-track">
              <motion.div
                className="bar-fill"
                initial={{ width: 0 }}
                animate={{ width: `${Math.max(ratio * 100, item.costMicro > 0n ? 1.5 : 0)}%` }}
                transition={{ duration: 0.4, ease: EASE }}
              />
            </div>
            <span className="bar-value">{item.valueLabel}</span>
          </div>
        );
      })}
    </div>
  );
}
